import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import "@/App.css";
import { captureAttribution } from "./lib/attribution";
import { AuthProvider } from "./context/AuthContext";
import { ChatProvider, useChat } from "./context/ChatContext";
import Landing from "./pages/Landing";
import Formular from "./pages/Formular";
import Danke from "./pages/Danke";
import LegalPage from "./pages/LegalPage";
import Redirect from "./pages/Redirect";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ErrorBoundary from "./components/ErrorBoundary";

function LandingWithChatParam() {
  const [params] = useSearchParams();
  const { openChat } = useChat();
  useEffect(() => {
    if (params.get("chat") === "1") openChat();
  }, [params, openChat]);
  return <Landing />;
}

function App() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ChatProvider>
            <ErrorBoundary>
            <Routes>
              <Route path="/" element={<LandingWithChatParam />} />
              <Route path="/formular" element={<Formular />} />
              <Route path="/danke" element={<Danke />} />
              <Route path="/impressum" element={<LegalPage slug="impressum" />} />
              <Route path="/datenschutz" element={<LegalPage slug="datenschutz" />} />
              <Route path="/whatsapp" element={<Redirect type="whatsapp" />} />
              <Route path="/anruf" element={<Redirect type="anruf" />} />
              <Route path="/chat" element={<Redirect type="chat" />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            </ErrorBoundary>
          </ChatProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
